module.exports = __webpack_public_path__ + "static/img/010.b556b824.png";